module.exports = __webpack_public_path__ + "assets/select.c7bd4816a8852cd371e16bce98c4650b.png";